import React, { useState, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Nav from "./Nav";
import { supabase } from "./supabaseClient";

const NAV_LINKS = [
  { label: "Home", href: "/", external: false },
  { label: "Hierarchy", href: "/hierarchy", external: false },
  { label: "Events", href: "/events", external: false },
];

const EXEC = [
  {
    name: "Eminent Oreo",
    role: "Chief Executive Officer",
    tier: "exec",
    avatar: "https://cdn.discordapp.com/avatars/692948977804509195/a_7d42d4c7008aa67fea48a34df6fbb49f.gif",
  },
  {
    name: "Hypx Eagle",
    role: "President",
    tier: "exec",
    avatar: "https://cdn.discordapp.com/avatars/321348585381691414/004d33c5cd23411e2e81fb8a02cca2d5.png",
  },
  {
    name: "ItCantBe",
    role: "Director of Strategic Development",
    tier: "exec",
    avatar: "https://cdn.discordapp.com/avatars/707039334896893994/80091ab619deb1c4472eea4966ee9b85.png",
  },
  {
    name: "SpartanBoy45",
    role: "Operations Liaison",
    tier: "exec",
    avatar: "https://cdn.discordapp.com/avatars/742775269516902511/a_a7e8a45c4f9d13820ecac576517a7b63.gif",
  },
];

const DIVISION_LEADS = [
  {
    name: "DarkDemonWolfx",
    role: "Director of Industry",
    division: "Industry",
    avatar: "https://cdn.discordapp.com/avatars/350586608426156032/5879286c5447fbaaea029733142a66db.png",
  },
  {
    name: "H_E_X_A_G_O_N",
    role: "Manager of Salvage Operations",
    division: "Industry",
    avatar: "https://cdn.discordapp.com/avatars/737443393399029852/b139091fafdcd568323924dff4c82b9f.png",
  },
  {
    name: "Mayhal",
    role: "Surface Operations Officer",
    division: "Industry",
    avatar: "https://cdn.discordapp.com/avatars/685994180539056282/3bb7051fe7a837b3ed097d895a33ec13.png",
  },
];

const LEADERSHIP = [
  { name: "Cupcake McSassyboots", role: "", avatar: "https://cdn.discordapp.com/avatars/847125535385714710/686a1551e4bf696e310d84975f355a94.png" },
  { name: "DARTH_DOOKS", role: "Unit 99th Squad Lead", avatar: "https://cdn.discordapp.com/avatars/805105704230322206/dc244cdfca67b57f56337f871010744d.png" },
  { name: "Keet_B", role: "", avatar: "https://cdn.discordapp.com/guilds/1171880733015556147/users/205136102133202953/avatars/740340542bff99e40a34fc290c7419de.png" },
  { name: "Techaddict2", role: "", avatar: "https://cdn.discordapp.com/avatars/251104319544229888/e6ddd22fb0d886677671c69690387625.png" },
  { name: "Traflanigav", role: "", avatar: "https://cdn.discordapp.com/avatars/279841917561208832/07a0c82419985789221b054041693ce2.png" },
  { name: "UndeadViking32", role: "Unit 99th Team Lead", avatar: "https://cdn.discordapp.com/avatars/1058512879734771712/99635b6e918364ff14effe881d078446.png" },
  { name: "Wargage", role: "Unit 99 Team Lead", avatar: "https://cdn.discordapp.com/avatars/375818437282234368/958664265258666d4c45435946c0132e.png" },
  { name: "sirredeemer", role: "", avatar: "https://cdn.discordapp.com/avatars/235578487639900160/c2c2acb700ac115a841380e94f4831e8.png" },
];

// Helper to convert team name to URL slug
function slugify(name) {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

const DIVISIONS = [
  {
    id: "industry",
    name: "Industry Division",
    color: "#fcd657",
    icon: "⛏",
    teamCount: 2,
    teams: [
      {
        name: "Mining",
        href: `/teams/mining`,
        internal: true,
        patch: "https://starkeeper.industries/storage/team-images/01KJ8PVVD8E3G39KN4EHGGY57W.png",
        desc: "The backbone of resource extraction. Our mining teams scour the 'verse for valuable materials to fuel the org's operations.",
      },
      {
        name: "Salvaging",
        href: `/teams/salvaging`,
        internal: true,
        patch: "https://starkeeper.industries/storage/team-images/01KJ8PX1WHE1C9ZPQAV42F8FEQ.png",
        desc: "What others leave behind, we reclaim. Salvage operations turn wrecks into wealth.",
      },
    ],
  },
  {
    id: "security",
    name: "Security Division",
    color: "#ef5350",
    icon: "🛡",
    teamCount: 8,
    teams: [
      {
        name: "Unit 99",
        href: `/teams/unit-99`,
        internal: true,
        patch: "https://starkeeper.industries/storage/team-images/01KK1FX2S39JND9YY2BB34A8QX.png",
        desc: "A Mil-Sim light team of 6 with a focus on teamwork as a cohesive squad. Training weekly with bunker missions, Onyx Facility runs and Contested Zones.",
      },
      {
        name: "Obsidian Reach",
        href: `/teams/obsidian-reach`,
        internal: true,
        patch: "https://starkeeper.industries/storage/team-images/01KJ8CY9NGN8930DPRTAVR8SG9.png",
        desc: "A neutral, independent team of ex-operatives, mercenaries, and scouts. Operating in the shadows — offering security, intelligence, and recovery across the fringe.",
      },
      {
        name: "Bridgeguard",
        href: `/teams/bridgeguard`,
        internal: true,
        patch: "https://starkeeper.industries/storage/team-images/01KJ8CYN70PYW1FRTWGK9PC1H9.png",
        desc: "Starkeeper's dedicated ship interior combat team with elements of space combat (fighters) and FPS combat (boarding/defending).",
      },
      {
        name: "Iron Warden",
        href: `/teams/iron-warden`,
        internal: true,
        patch: null,
        desc: "The big-ship squad. Crewing Idris, Polaris, and Perseus vessels — captains, turret gunners, engineers all have a place. Keep the guns online and the ship unbroken.",
      },
      {
        name: "Onyx",
        href: `/teams/onyx`,
        internal: true,
        patch: null,
        desc: "Providing 'Un-Healthcare' to anyone who threatens the fleet. Establishing aerial dominance wherever Starkeeper Industries operates.",
      },
      {
        name: "Elysian Vanguard",
        href: `/teams/elysian-vanguard`,
        internal: true,
        patch: "https://starkeeper.industries/storage/team-images/01KK1H8JVY7K25B116WF43FAGC.png",
        desc: "Specializing in transport and Close Air Support. Getting Starkeepers in and out of the fight while being their eyes in the sky.",
      },
      {
        name: "Starkeeper Rx",
        href: `/teams/starkeeper-rx`,
        internal: true,
        patch: "https://starkeeper.industries/storage/team-images/01KJD6XQK69M3Q74FPH52ECZB9.png",
        desc: "The lifeline of Starkeeper Industries — medics deploying across capital ships, dropships, and ground teams. Every Starkeeper makes it home.",
      },
      {
        name: "The Sovereign Revenant",
        href: `/teams/the-sovereign-revenant`,
        internal: true,
        patch: "https://starkeeper.industries/storage/team-images/01KJWM2B761W51KNBP5RCWYY3F.png",
        desc: "A capital-class crew built around the Idris as both warship and home. Exploring, mining, transporting, salvaging, and engaging in piracy when opportunities arise.",
      },
    ],
  },
];

// ── Shared Components ──────────────────────────────────────────────────────────

function StarField() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animId;
    const stars = Array.from({ length: 350 }, () => ({
      x: Math.random(), y: Math.random(),
      r: Math.random() * 1.8 + 0.3,
      a: Math.random(), speed: Math.random() * 0.004 + 0.001,
    }));
    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    resize();
    window.addEventListener("resize", resize);
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach((s) => {
        s.a += s.speed;
        if (s.a > 1) s.a = 0;
        const alpha = Math.sin(s.a * Math.PI) * 0.85 + 0.15;
        ctx.beginPath();
        ctx.arc(s.x * canvas.width, s.y * canvas.height, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${alpha})`;
        ctx.fill();
      });
      animId = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(animId); window.removeEventListener("resize", resize); };
  }, []);
  return (
    <canvas ref={canvasRef} style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100vh",
      pointerEvents: "none", zIndex: 0,
    }} />
  );
}

function useScrollReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
}

function Reveal({ children, delay = 0, style = {} }) {
  const [ref, visible] = useScrollReveal();
  return (
    <div ref={ref} style={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(32px)",
      transition: `opacity 0.65s ease ${delay}s, transform 0.65s ease ${delay}s`,
      ...style,
    }}>
      {children}
    </div>
  );
}

function SectionLabel({ children }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 12 }}>
      <div style={{ width: 48, height: 2, background: "#fcd657", flexShrink: 0 }} />
      <span style={{
        fontFamily: "'Space Mono', monospace", fontSize: 10,
        letterSpacing: 4, color: "#fcd657", textTransform: "uppercase",
      }}>{children}</span>
    </div>
  );
}

function Avatar({ src, name, size = 72, borderColor = "rgba(252,214,87,0.4)" }) {
  const [err, setErr] = useState(false);
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      border: `2px solid ${borderColor}`,
      overflow: "hidden", flexShrink: 0,
      background: "#0d1120",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      {!err
        ? <img src={src} alt={name} onError={() => setErr(true)}
            style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        : <span style={{ fontFamily: "'Orbitron'", fontSize: size * 0.35, color: "#fcd657", fontWeight: 700 }}>
            {name.charAt(0).toUpperCase()}
          </span>
      }
    </div>
  );
}

// ── Member Cards ───────────────────────────────────────────────────────────────

const GUEST_BADGE = { fontFamily: "'Space Mono', monospace", fontSize: 7, letterSpacing: 2, color: '#ff9800', border: '1px solid rgba(255,152,0,0.4)', padding: '1px 6px', background: 'rgba(255,152,0,0.08)', verticalAlign: 'middle', marginLeft: 6 };

function ExecCard({ member, delay }) {
  const [hovered, setHovered] = useState(false);
  const card = (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
        style={{
          position: "relative",
          padding: "32px 28px",
          height: "100%", boxSizing: "border-box",
          border: `1px solid ${hovered ? "rgba(252,214,87,0.6)" : "rgba(252,214,87,0.2)"}`,
          background: hovered ? "rgba(252,214,87,0.06)" : "rgba(255,255,255,0.02)",
          transition: "all 0.3s ease",
          clipPath: "polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px))",
          boxShadow: hovered ? "0 0 40px rgba(252,214,87,0.15)" : "none",
          display: "flex", flexDirection: "column", alignItems: "center", gap: 16, textAlign: "center",
        }}
      >
        <Avatar src={member.avatar} name={member.name} size={80} />
        <div>
          <div style={{
            fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
            fontSize: 15, color: "#e8eaf6", marginBottom: 6, letterSpacing: 1,
          }}>{member.name}{member.status === 'guest' && <span style={GUEST_BADGE}>GUEST</span>}</div>
          <div style={{
            fontFamily: "'Space Mono', monospace", fontSize: 9,
            letterSpacing: 2, color: "#fcd657", textTransform: "uppercase",
          }}>{member.role}</div>
        </div>
        {/* corner accents */}
        <div style={{ position: "absolute", top: 0, left: 0, width: 20, height: 20,
          borderTop: "2px solid #fcd657", borderLeft: "2px solid #fcd657" }} />
        <div style={{ position: "absolute", bottom: 0, right: 0, width: 20, height: 20,
          borderBottom: "2px solid #fcd657", borderRight: "2px solid #fcd657" }} />
      </div>
  );
  return (
    <Reveal delay={delay} style={{ height: "100%" }}>
      {member.id
        ? <Link to={`/profile/${member.id}`} style={{ textDecoration: "none", display: "block", cursor: "pointer", height: "100%" }}>{card}</Link>
        : card
      }
    </Reveal>
  );
}

function LeaderCard({ member, delay, accentColor = "#fcd657" }) {
  const [hovered, setHovered] = useState(false);
  const card = (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
        style={{
          display: "flex", alignItems: "center", gap: 16,
          padding: "16px 20px",
          border: `1px solid ${hovered ? accentColor + "55" : "rgba(255,255,255,0.07)"}`,
          background: hovered ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.015)",
          transition: "all 0.25s ease",
          borderRadius: 2,
        }}
      >
        <Avatar src={member.avatar} name={member.name} size={48} />
        <div>
          <div style={{
            fontFamily: "'Rajdhani', sans-serif", fontWeight: 600,
            fontSize: 16, color: "#e8eaf6",
          }}>{member.name}{member.status === 'guest' && <span style={GUEST_BADGE}>GUEST</span>}</div>
          {member.role && (
            <div style={{
              fontFamily: "'Space Mono', monospace", fontSize: 9,
              letterSpacing: 1.5, color: accentColor, opacity: 0.8, textTransform: "uppercase",
            }}>{member.role}</div>
          )}
        </div>
      </div>
  );
  return (
    <Reveal delay={delay}>
      {member.id
        ? <Link to={`/profile/${member.id}`} style={{ textDecoration: "none", display: "block" }}>{card}</Link>
        : card
      }
    </Reveal>
  );
}

function CrewCard({ member, delay }) {
  const [hovered, setHovered] = useState(false);
  const card = (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex", alignItems: "center", gap: 12,
        padding: "10px 16px",
        border: `1px solid ${hovered ? "rgba(232,234,246,0.2)" : "rgba(255,255,255,0.05)"}`,
        background: hovered ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.01)",
        transition: "all 0.25s ease",
        borderRadius: 2,
      }}
    >
      <Avatar src={member.avatar} name={member.name} size={36} borderColor="rgba(232,234,246,0.2)" />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontFamily: "'Rajdhani', sans-serif", fontWeight: 600,
          fontSize: 14, color: "#e8eaf6",
          whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
        }}>{member.name}{member.status === 'guest' && <span style={GUEST_BADGE}>GUEST</span>}</div>
        {member.role && (
          <div style={{
            fontFamily: "'Space Mono', monospace", fontSize: 8,
            letterSpacing: 1.5, color: "rgba(232,234,246,0.35)", textTransform: "uppercase",
          }}>{member.role}</div>
        )}
      </div>
    </div>
  );
  return (
    <Reveal delay={delay}>
      {member.id
        ? <Link to={`/profile/${member.id}`} style={{ textDecoration: "none", display: "block" }}>{card}</Link>
        : card
      }
    </Reveal>
  );
}

function TeamCard({ team, color, delay }) {
  const [expanded, setExpanded] = useState(false);
  const [hovered, setHovered] = useState(false);
  return (
    <Reveal delay={delay}>
      <div
        style={{
          border: `1px solid ${hovered || expanded ? color + "55" : "rgba(255,255,255,0.07)"}`,
          background: expanded ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.02)",
          transition: "all 0.3s ease",
          overflow: "hidden",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* Header row */}
        <div
          onClick={() => setExpanded(!expanded)}
          style={{
            display: "flex", alignItems: "center", gap: 16,
            padding: "20px 24px", cursor: "pointer",
          }}
        >
          {team.patch ? (
            <img src={team.patch} alt={team.name}
              style={{ width: 48, height: 48, objectFit: "contain", flexShrink: 0 }}
              onError={(e) => { e.target.style.display = "none"; }}
            />
          ) : (
            <div style={{
              width: 48, height: 48, flexShrink: 0,
              background: `${color}22`, border: `1px solid ${color}44`,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 20,
            }}>🛡</div>
          )}
          <div style={{ flex: 1 }}>
            <div style={{
              fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
              fontSize: 14, color: "#e8eaf6", letterSpacing: 1,
            }}>{team.name}</div>
          </div>
          <div style={{
            fontFamily: "'Space Mono', monospace", fontSize: 14,
            color: color, transition: "transform 0.3s",
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
          }}>▾</div>
        </div>

        {/* Expanded desc */}
        <div style={{
          maxHeight: expanded ? 200 : 0,
          overflow: "hidden",
          transition: "max-height 0.4s ease",
        }}>
          <div style={{
            padding: "0 24px 20px",
            borderTop: `1px solid ${color}22`,
            paddingTop: 16,
          }}>
            <p style={{
              fontFamily: "'Rajdhani', sans-serif", fontSize: 15,
              color: "rgba(232,234,246,0.6)", lineHeight: 1.7,
              marginBottom: 14,
            }}>{team.desc}</p>
            {team.internal ? (
              <Link to={team.href}
                style={{
                  fontFamily: "'Space Mono', monospace", fontSize: 9,
                  letterSpacing: 2, color: color, textTransform: "uppercase",
                  textDecoration: "none", borderBottom: `1px solid ${color}55`,
                  paddingBottom: 2, transition: "opacity 0.2s",
                }}
                onMouseEnter={e => e.target.style.opacity = "0.7"}
                onMouseLeave={e => e.target.style.opacity = "1"}
              >View Team Page →</Link>
            ) : (
              <a href={team.href}
                style={{
                  fontFamily: "'Space Mono', monospace", fontSize: 9,
                  letterSpacing: 2, color: color, textTransform: "uppercase",
                  textDecoration: "none", borderBottom: `1px solid ${color}55`,
                  paddingBottom: 2, transition: "opacity 0.2s",
                }}
                onMouseEnter={e => e.target.style.opacity = "0.7"}
                onMouseLeave={e => e.target.style.opacity = "1"}
              >View Team Page →</a>
            )}
          </div>
        </div>
      </div>
    </Reveal>
  );
}

// ── Main Page ──────────────────────────────────────────────────────────────────

export default function HierarchyPage() {
  // Read ?tab= from the URL so callers (e.g. team page's "All Teams" button)
  // can deep-link straight into the Divisions view.
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "divisions" ? "divisions" : "roles";
  const [activeTab, setActiveTab] = useState(initialTab);
  const [commandMembers, setCommandMembers] = useState([]);
  const [divLeadMembers, setDivLeadMembers] = useState([]);
  const [teamLeadMembers, setTeamLeadMembers] = useState([]);
  const [crewMembers, setCrewMembers] = useState([]);
  const [dynamicDivisions, setDynamicDivisions] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(true);

  useEffect(() => {
    async function loadAll() {
      setRolesLoading(true);
      const [rolesRes, crewRes, teamsRes, tlRes] = await Promise.all([
        supabase.from("profiles").select("id, discord_username, discord_avatar, org_role, org_role_sort, managed_team, member_status").not("org_role_sort", "is", null).order("org_role_sort"),
        supabase.from("profiles").select("id, discord_username, discord_avatar, org_role, org_role_sort, managed_team, member_status").order("discord_username"),
        supabase.from("teams").select("id, name, description, tagline, patch_url, divisions, division, color, archived").eq("archived", false).order("name"),
        supabase.from("profiles").select("id, discord_username, discord_avatar, org_role, org_role_sort, managed_team, member_status").eq("perm_team_lead", true),
      ]);

      if (crewRes.error) console.error("[Hierarchy] crew query error:", crewRes.error);

      // Hide pending users (not approved yet) AND left/departed members
      // (soft-deleted by the Discord leaver-detection pass). Org leadership
      // surfaces should reflect the current active org, not historical state.
      const isVisibleMember = (p) => p.member_status !== 'pending' && p.member_status !== 'left';
      const sortedProfiles = (rolesRes.data || []).filter(isVisibleMember);
      const allMembers = (crewRes.data || []).filter(isVisibleMember);
      const allTeams = teamsRes.data || [];
      const teamLeadProfiles = (tlRes.data || []).filter(isVisibleMember);
      console.log("[Hierarchy] leaders:", sortedProfiles.length, "allMembers:", allMembers.length);

      setCommandMembers(sortedProfiles.filter(p => p.org_role_sort >= 1 && p.org_role_sort < 2));
      setDivLeadMembers(sortedProfiles.filter(p => p.org_role_sort >= 2 && p.org_role_sort < 3));

      // Team leads: from sort range + perm flag, deduped
      const bySort = sortedProfiles.filter(p => p.org_role_sort >= 3 && p.org_role_sort < 4);
      const byPerm = (teamLeadProfiles || []).filter(p => !bySort.find(s => s.id === p.id));
      const seen = new Set();
      const combined = [...bySort, ...byPerm].filter(p => { if (seen.has(p.id)) return false; seen.add(p.id); return true; });
      setTeamLeadMembers(combined);

      // Crew: everyone not in command/divLead/teamLead tiers
      const leaderIds = new Set([
        ...sortedProfiles.filter(p => p.org_role_sort >= 1 && p.org_role_sort < 4).map(p => p.id),
        ...combined.map(p => p.id),
      ]);
      setCrewMembers(allMembers.filter(p => !leaderIds.has(p.id)));

      // Divisions — Industry and Security only
      const DIVISION_CONFIG = [
        { id: "industry", name: "Industry Division", color: "#fcd657", icon: "⛏" },
        { id: "security", name: "Security Division", color: "#ef5350", icon: "🛡" },
      ];
      const built = DIVISION_CONFIG.map(div => {
        const divTeams = allTeams.filter(t => {
          const divs = Array.isArray(t.divisions) ? t.divisions : (t.division ? [t.division] : []);
          return divs.some(d => d.toLowerCase() === div.id || d.toLowerCase().startsWith(div.id));
        });
        return { ...div, teams: divTeams };
      });
      setDynamicDivisions(built);
      setRolesLoading(false);
    }
    loadAll();
  }, []);

  return (
    <div style={{
      fontFamily: "'Rajdhani', 'Orbitron', sans-serif",
      background: "#05070f",
      color: "#e8eaf6",
      minHeight: "100vh",
      overflowX: "hidden",
    }}>
      <StarField />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@300;400;500;600;700&family=Orbitron:wght@400;600;700;900&family=Space+Mono&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::selection { background: #fcd657; color: #05070f; }
        a { text-decoration: none; color: inherit; }
        .nav-link {
          font-family: 'Orbitron', sans-serif; font-size: 11px;
          letter-spacing: 2.5px; text-transform: uppercase;
          color: rgba(232,234,246,0.55); transition: color 0.2s;
          padding: 4px 0; position: relative;
        }
        .nav-link::after {
          content: ''; position: absolute; bottom: 0; left: 0;
          width: 0; height: 1px; background: #fcd657; transition: width 0.3s ease;
        }
        .nav-link:hover { color: #fcd657; }
        .nav-link:hover::after { width: 100%; }
        .tab-btn {
          font-family: 'Orbitron', sans-serif; font-size: 11px;
          letter-spacing: 2px; text-transform: uppercase;
          padding: 12px 28px; border: none; cursor: pointer;
          transition: all 0.25s ease; background: transparent;
        }
        @keyframes floatUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .scanline {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          pointer-events: none; z-index: 9999;
          background: repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.03) 2px, rgba(0,0,0,0.03) 4px);
        }
      `}</style>

      <div className="scanline" />

      <Nav accentColor="#fcd657" />

      {/* PAGE HEADER */}
      <section style={{
        paddingTop: "calc(140px + env(safe-area-inset-top, 0px))", paddingBottom: 80, paddingLeft: 40, paddingRight: 40,
        maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 1,
      }}>
        <div style={{
          opacity: 0, animation: "floatUp 0.7s ease forwards 0.2s",
        }}>
          <SectionLabel>Command Structure</SectionLabel>
          <h1 style={{
            fontFamily: "'Orbitron', sans-serif", fontWeight: 900,
            fontSize: "clamp(36px, 7vw, 80px)", lineHeight: 0.95,
            color: "#e8eaf6", marginBottom: 20,
          }}>
            ORG<br /><span style={{ color: "#fcd657" }}>HIERARCHY</span>
          </h1>
          <p style={{
            fontFamily: "'Rajdhani', sans-serif", fontSize: 19,
            color: "rgba(232,234,246,0.5)", maxWidth: 520, lineHeight: 1.7,
          }}>
            From the Executive Leadership Team down to specialist squads —
            every Starkeeper has a place in the 'verse.
          </p>
        </div>
      </section>

      {/* TAB SWITCHER — outer wrapper keeps the full-width top/bottom borders;
          inner div mirrors the maxWidth/padding the content sections use so the
          tab buttons line up with "Command" / division headers below. */}
      <div style={{
        position: "relative", zIndex: 1,
        borderTop: "1px solid rgba(255,255,255,0.06)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        background: "rgba(0,0,0,0.3)",
      }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 40px", display: "flex" }}>
          {[
            { id: "roles", label: "Org Roles" },
            { id: "divisions", label: "Divisions" },
          ].map((tab) => (
            <button
              key={tab.id}
              className="tab-btn"
              onClick={() => setActiveTab(tab.id)}
              style={{
                color: activeTab === tab.id ? "#fcd657" : "rgba(232,234,246,0.4)",
                borderBottom: activeTab === tab.id ? "2px solid #fcd657" : "2px solid transparent",
              }}
            >{tab.label}</button>
          ))}
        </div>
      </div>

      {/* ── TAB: ORG ROLES ── */}
      {activeTab === "roles" && (
        <div style={{ position: "relative", zIndex: 1, maxWidth: 1100, margin: "0 auto", padding: "80px 40px 120px" }}>

          {/* Executive Leadership */}
          <Reveal>
            <SectionLabel>Executive Leadership Team</SectionLabel>
            <h2 style={{
              fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
              fontSize: "clamp(20px, 3vw, 32px)", color: "#e8eaf6", marginBottom: 40,
            }}>Command</h2>
          </Reveal>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
            gap: 20, marginBottom: 80,
          }}>
            {rolesLoading ? (
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.3)", letterSpacing: 2, padding: 20 }}>LOADING...</div>
            ) : commandMembers.length === 0 ? (
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.2)", letterSpacing: 2, padding: 20 }}>NO COMMAND ROLES ASSIGNED YET</div>
            ) : commandMembers.map((m, i) => (
              <ExecCard key={m.id} member={{ id: m.id, name: m.discord_username, role: m.org_role, avatar: m.discord_avatar, status: m.member_status }} delay={i * 0.08} />
            ))}
          </div>

          {/* Org connector line */}
          <Reveal>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 40 }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0 }}>
                <div style={{ width: 1, height: 40, background: "linear-gradient(to bottom, #fcd657, rgba(252,214,87,0.2))" }} />
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#fcd657", boxShadow: "0 0 12px #fcd657" }} />
                <div style={{ width: 1, height: 40, background: "linear-gradient(to bottom, rgba(252,214,87,0.2), transparent)" }} />
              </div>
            </div>
          </Reveal>

          {/* Division Leads */}
          <Reveal>
            <SectionLabel>Division Leads</SectionLabel>
            <h2 style={{
              fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
              fontSize: "clamp(20px, 3vw, 32px)", color: "#e8eaf6", marginBottom: 40,
            }}>Operations Command</h2>
          </Reveal>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: 16, marginBottom: 80,
          }}>
            {rolesLoading ? (
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.3)", letterSpacing: 2, padding: 20 }}>LOADING...</div>
            ) : divLeadMembers.length === 0 ? (
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.2)", letterSpacing: 2, padding: 20 }}>NO DIVISION LEADS ASSIGNED YET</div>
            ) : divLeadMembers.map((m, i) => (
              <LeaderCard key={m.id} member={{ id: m.id, name: m.discord_username, role: m.org_role, avatar: m.discord_avatar, status: m.member_status }} delay={i * 0.08} accentColor="#fcd657" />
            ))}
          </div>

          {/* Connector */}
          <Reveal>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 40 }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ width: 1, height: 40, background: "linear-gradient(to bottom, rgba(252,214,87,0.3), rgba(252,214,87,0.1))" }} />
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: "rgba(252,214,87,0.5)" }} />
                <div style={{ width: 1, height: 40, background: "linear-gradient(to bottom, rgba(252,214,87,0.1), transparent)" }} />
              </div>
            </div>
          </Reveal>

          {/* Leadership */}
          <Reveal>
            <SectionLabel>Leadership</SectionLabel>
            <h2 style={{
              fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
              fontSize: "clamp(20px, 3vw, 32px)", color: "#e8eaf6", marginBottom: 40,
            }}>Team Leaders</h2>
          </Reveal>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: 12,
          }}>
            {rolesLoading ? (
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.3)", letterSpacing: 2, padding: 20 }}>LOADING...</div>
            ) : teamLeadMembers.length === 0 ? (
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.2)", letterSpacing: 2, padding: 20 }}>NO TEAM LEADS ASSIGNED YET</div>
            ) : teamLeadMembers.map((m, i) => (
              <LeaderCard key={m.id} member={{ id: m.id, name: m.discord_username, role: m.managed_team || m.org_role || "", avatar: m.discord_avatar, status: m.member_status }} delay={i * 0.06} accentColor="rgba(232,234,246,0.4)" />
            ))}
          </div>

          {/* Connector */}
          <Reveal>
            <div style={{ display: "flex", justifyContent: "center", margin: "40px 0" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ width: 1, height: 40, background: "linear-gradient(to bottom, rgba(232,234,246,0.2), rgba(232,234,246,0.08))" }} />
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: "rgba(232,234,246,0.25)" }} />
                <div style={{ width: 1, height: 40, background: "linear-gradient(to bottom, rgba(232,234,246,0.08), transparent)" }} />
              </div>
            </div>
          </Reveal>

          {/* Crew Members */}
          <Reveal>
            <SectionLabel>Members</SectionLabel>
            <h2 style={{
              fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
              fontSize: "clamp(20px, 3vw, 32px)", color: "#e8eaf6", marginBottom: 40,
            }}>Specialists</h2>
          </Reveal>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
            gap: 8,
          }}>
            {rolesLoading ? (
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.3)", letterSpacing: 2, padding: 20 }}>LOADING...</div>
            ) : crewMembers.length === 0 ? (
              <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.2)", letterSpacing: 2, padding: 20 }}>NO CREW MEMBERS YET</div>
            ) : crewMembers.map((m, i) => (
              <CrewCard key={m.id} member={{ id: m.id, name: m.discord_username, role: m.org_role || "", avatar: m.discord_avatar, status: m.member_status }} delay={Math.min(i * 0.03, 0.8)} />
            ))}
          </div>
        </div>
      )}

      {/* ── TAB: DIVISIONS ── */}
      {activeTab === "divisions" && (
        <div style={{ position: "relative", zIndex: 1, maxWidth: 1100, margin: "0 auto", padding: "80px 40px 120px" }}>
          {dynamicDivisions.length === 0 ? (
            <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 10, color: "rgba(255,255,255,0.3)", letterSpacing: 2, textAlign: "center", padding: 60 }}>LOADING DIVISIONS...</div>
          ) : dynamicDivisions.map((div, di) => (
            <div key={div.id} style={{ marginBottom: 80 }}>
              <Reveal delay={di * 0.1}>
                <div style={{ display: "flex", alignItems: "center", gap: 20, marginBottom: 40 }}>
                  <div style={{
                    width: 56, height: 56, flexShrink: 0,
                    background: `${div.color}15`,
                    border: `2px solid ${div.color}55`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 24,
                    clipPath: "polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%)",
                  }}>{div.icon}</div>
                  <div>
                    <div style={{
                      fontFamily: "'Space Mono', monospace", fontSize: 9,
                      letterSpacing: 4, color: div.color, marginBottom: 4, textTransform: "uppercase",
                    }}>{div.teams.length} Team{div.teams.length !== 1 ? "s" : ""}</div>
                    <h2 style={{
                      fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
                      fontSize: "clamp(20px, 3vw, 34px)", color: "#e8eaf6",
                    }}>{div.name}</h2>
                  </div>
                </div>
              </Reveal>

              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {div.teams.length === 0 ? (
                  <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 9, color: "rgba(255,255,255,0.2)", letterSpacing: 2, padding: "16px 0" }}>NO TEAMS IN THIS DIVISION YET</div>
                ) : div.teams.map((team, ti) => (
                  <TeamCard key={team.id} team={{
                    name: team.name,
                    href: `/teams/${team.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`,
                    internal: true,
                    patch: team.patch_url || null,
                    desc: team.tagline || team.description || "",
                  }} color={div.color} delay={ti * 0.06} />
                ))}
              </div>

              {di < dynamicDivisions.length - 1 && (
                <div style={{
                  height: 1, background: "linear-gradient(to right, transparent, rgba(255,255,255,0.07), transparent)",
                  marginTop: 60,
                }} />
              )}
            </div>
          ))}
        </div>
      )}

      {/* FOOTER */}
      <footer style={{
        position: "relative", zIndex: 1,
        borderTop: "1px solid rgba(255,255,255,0.07)",
        padding: "40px 40px",
        background: "rgba(0,0,0,0.4)",
      }}>
        <div style={{
          maxWidth: 1100, margin: "0 auto",
          display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 20,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img src="/images/logo.png" alt="Starkeeper"
              style={{ height: 28, width: "auto" }}
              onError={(e) => { e.target.style.display = "none"; }} />
            <span style={{
              fontFamily: "'Orbitron', sans-serif", fontWeight: 700,
              fontSize: 12, letterSpacing: 2.5, color: "rgba(232,234,246,0.4)",
            }}>STARKEEPER INDUSTRIES</span>
          </div>
          <div style={{ display: "flex", gap: 28, flexWrap: "wrap" }}>
            {NAV_LINKS.map((l) => (
              l.external
                ? <a key={l.label} href={l.href} style={{
                    fontFamily: "'Space Mono', monospace", fontSize: 9,
                    letterSpacing: 2, color: "rgba(232,234,246,0.3)", textTransform: "uppercase",
                    transition: "color 0.2s",
                  }}
                    onMouseEnter={e => e.target.style.color = "#fcd657"}
                    onMouseLeave={e => e.target.style.color = "rgba(232,234,246,0.3)"}
                  >{l.label}</a>
                : <Link key={l.label} to={l.href} style={{
                    fontFamily: "'Space Mono', monospace", fontSize: 9,
                    letterSpacing: 2, color: "rgba(232,234,246,0.3)", textTransform: "uppercase",
                    transition: "color 0.2s", textDecoration: "none",
                  }}
                    onMouseEnter={e => e.target.style.color = "#fcd657"}
                    onMouseLeave={e => e.target.style.color = "rgba(232,234,246,0.3)"}
                  >{l.label}</Link>
            ))}
          </div>
        </div>
        <div style={{
          maxWidth: 1100, margin: "20px auto 0",
          fontFamily: "'Space Mono', monospace", fontSize: 9, letterSpacing: 1.2,
          color: "rgba(232,234,246,0.18)",
          borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: 20, lineHeight: 1.8,
        }}>
          © 2026 Starkeeper Industries. All rights reserved. · This is an unofficial fansite. Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. Not affiliated with Cloud Imperium or Roberts Space Industries.
        </div>
      </footer>
    </div>
  );
}
